/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contributions_CaptionInputs */

const en_contributions_caption = /** @type {(inputs: Contributions_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contribution graph for the last year`)
};

const ar_contributions_caption = /** @type {(inputs: Contributions_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`رسم مساهمات آخر سنة`)
};

const bn_contributions_caption = /** @type {(inputs: Contributions_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`গত এক বছরের কন্ট্রিবিউশন গ্রাফ`)
};

const de_contributions_caption = /** @type {(inputs: Contributions_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beitragsdiagramm für das letzte Jahr`)
};

const es_contributions_caption = /** @type {(inputs: Contributions_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gráfico de contribuciones del último año`)
};

const fr_contributions_caption = /** @type {(inputs: Contributions_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Graphique des contributions de l'année dernière`)
};

const pt_contributions_caption = /** @type {(inputs: Contributions_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gráfico de contribuições do último ano`)
};

const zh_contributions_caption = /** @type {(inputs: Contributions_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`过去一年的贡献图`)
};

const tr_contributions_caption = /** @type {(inputs: Contributions_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Son bir yılın katkı grafiği`)
};

const ru_contributions_caption = /** @type {(inputs: Contributions_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`График вкладов за последний год`)
};

const pl_contributions_caption = /** @type {(inputs: Contributions_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wykres kontrybucji z ostatniego roku`)
};

/**
* | output |
* | --- |
* | "Contribution graph for the last year" |
*
* @param {Contributions_CaptionInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const contributions_caption = /** @type {((inputs?: Contributions_CaptionInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contributions_CaptionInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_contributions_caption(inputs)
	if (locale === "bn") return bn_contributions_caption(inputs)
	if (locale === "de") return de_contributions_caption(inputs)
	if (locale === "es") return es_contributions_caption(inputs)
	if (locale === "fr") return fr_contributions_caption(inputs)
	if (locale === "pt") return pt_contributions_caption(inputs)
	if (locale === "zh") return zh_contributions_caption(inputs)
	if (locale === "tr") return tr_contributions_caption(inputs)
	if (locale === "ru") return ru_contributions_caption(inputs)
	if (locale === "pl") return pl_contributions_caption(inputs)
	return en_contributions_caption(inputs)
});